import React from 'react';
import { T, getTheme, setTheme } from '../constants';

// Sits next to MuteToggle in the Navbar. Click toggles between the
// light and dark palettes; setTheme() persists the choice and reloads.
export default function ThemeToggle() {
  const isDark = getTheme() === 'dark';
  return (
    <button
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      style={{
        display: 'flex', alignItems: 'center', gap: 4,
        padding: '3px 9px',
        background: T.purpleBg,
        border: `1px solid ${T.purpleBorder}`,
        color: T.purple,
        borderRadius: 3, fontSize: 10, fontWeight: 700,
        letterSpacing: '0.05em', cursor: 'pointer',
      }}
    >
      <span style={{ fontSize: 11 }}>{isDark ? '☀️' : '🌙'}</span>
      {isDark ? 'LIGHT' : 'DARK'}
    </button>
  );
}
